import axios from 'axios';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { check_active_plugins, checkPlugin_widget, set_nexter_widgets, get_widget_list, install_activate_plugin, wdKit_Form_data, Wkit_availble_not } from '../../helper/helper-function';
import ReactPaginate from 'react-paginate';
import '../preset/preset.scss';

import { __ } from '@wordpress/i18n';
import { connect } from 'react-redux';
import { ShowToast } from '../redux/redux_data/store_action';

let controller = new AbortController();

const { Fragment } = wp.element;

const Preset = (props) => {

    /**DropDown data for Preset Name */
    const widget_list = {
        elementor: [
            {
                name: 'Accordion',
                tag: 'freemium'
            },
            {
                name: 'Age Gate',
                id: '16001',
            },
            {
                name: 'Audio Player',
                tag: 'pro',
                id: '16295',
            },
            {
                name: 'Blockquote',
                id: '16317',
            },
            {
                name: 'Button',
                id: '16452',
            },
            {
                name: 'Breadcrumbs Bar',
                id: '17013',
            },
            {
                name: 'Chart',
                id: '12558',
            },
            {
                name: 'Count Down',
                tag: 'freemium',
                id: '12337',
            },
            {
                name: 'Coupon Code',
                tag: 'pro',
                id: '16377',
            },
            {
                name: 'Carousel Anything',
                tag: 'freemium',
                id: '17360',
            },
            {
                name: 'Dynamic Categories',
                tag: 'freemium',
            },
            {
                name: 'Dark Mode',
            },
            {
                name: 'Heading Title',
                id: '12427',
            },
            {
                name: 'Info Box',
                tag: 'freemium',
                id: '16254',
            },
            {
                name: 'Message Box',
                id: '12363',
            },
            {
                name: 'Navigation Menu',
                tag: 'pro',
            },
            {
                name: 'Number Counter',
                tag: 'freemium',
                id: '12570',
            },
            {
                name: 'Progress Bar',
                id: '16111',
            },
            {
                name: 'Pricing List',
                tag: 'pro',
                id: '12454',
            },
            {
                name: 'Post Title',
            },
            {
                name: 'Pricing Table',
                tag: 'freemium',
                id: '12387',
            },
            {
                name: 'Protected Content',
                tag: 'pro',
                id: '12523',
            },
            {
                name: 'Post Content',
            },
            {
                name: 'Post Featured Image',
            },
            {
                name: 'Pre Loader',
                tag: 'pro',
                id: '16575',
            },
            {
                name: 'Post Prev/Next',
            },
            {
                name: 'Post Author',
            },
            {
                name: 'Post Comment',
            },
            {
                name: 'Post Meta',
            },
            {
                name: 'Row Background',
                tag: 'pro',
            },
            {
                name: 'Stylish List',
                tag: 'freemium',
                id: '16789',
            },
            {
                name: 'Syntax Highlighter',
                tag: 'freemium',
                id: '12518',
            },
            {
                name: 'Site Logo',
                tag: 'pro',
            },
            {
                name: 'Table',
                tag: 'freemium',
                id: '16051',
            },
            {
                name: 'Table Of Content',
                tag: 'pro'
            },
            {
                name: 'Tabs/Tours',
                tag: 'freemium',
            },
            {
                name: 'Text Block',
            },
            {
                name: 'Google Map',
                tag: 'pro',
                id: '16989',
            },
            {
                name: 'Video Player',
                id: '16867',
            },
            {
                name: 'WP Login & Register',
                tag: 'pro',
                id: '16013',
            },
            // {
            //     name: 'Post Search',
            //     tag: 'DEPRECATED'
            // },
            {
                name: 'Header Meta Content',
                tag: 'freemium'
            },
            {
                name: 'Horizontal Scroll',
                tag: 'pro',
                id: '16037',
            },
            {
                name: 'Creative Image',
                tag: 'pro',
                id: '17091',
            },
            {
                name: 'Mobile Menu',
                tag: 'pro'
            },
            {
                name: 'Navigation Menu Lite',
            },
            {
                name: 'Page Scroll',
                tag: 'freemium'
            },
            {
                name: 'Scroll Sequence',
                tag: 'pro'
            },
            {
                name: 'Design Tool',
                tag: 'pro'
            },
            {
                name: 'Advanced Buttons',
                tag: 'pro',
                id: '11908',
            },
            {
                name: 'Advanced Typography',
                tag: 'pro',
                id: '11964',
            },
            {
                name: 'Advanced Banner',
                tag: 'pro',
                id: '12004',
            },
            {
                name: 'Advanced Separators',
                tag: 'pro'
            },
            {
                name: 'Advanced Service Boxes',
                tag: 'pro'
            },
            {
                name: 'Heading Animation',
                id: '17060',
            },
            {
                name: 'Before After',
                tag: 'pro',
                id: '12153',
            },
            {
                name: 'Crousel Remote',
                tag: 'pro',
                id: '12220',
            },
            {
                name: 'Circle Menu',
                tag: 'pro',
                id: '17173',
            },
            {
                name: 'Cascading Image',
                tag: 'pro',
                id: '17196',
            },
            {
                name: 'Draw SVG',
                tag: 'pro',
                id: '17178',
            },
            {
                name: 'Dynamic Device',
                tag: 'pro',
                id: '12270',
            },
            {
                name: 'Flip Box',
                tag: 'freemium',
                id: '12274',
            },
            {
                name: 'Hotspot',
                tag: 'pro',
                id: '12282',
            },
            {
                name: 'Hover Card',
                id: '17376',
            },
            {
                name: 'LottieFiles Animation',
                tag: 'pro',
                id: '17352',
            },
            {
                name: 'Smooth Scroll',
            },
            {
                name: 'Morphing Layouts',
                tag: 'pro',
                id: '17219',
            },
            {
                name: 'Mouse Cursor',
                tag: 'pro',
                id: '17249',
            },
            {
                name: 'Popup Builder / Off Canvas',
                tag: 'pro',
                id: '11802',
            },
            {
                name: 'Process Steps',
                tag: 'pro',
                id: '17271',
            },
            {
                name: 'Scroll Navigation',
                tag: 'freemium',
                id: '17342',
            },
            {
                name: 'Switcher',
                tag: 'freemium',
                id: '17879',
            },
            {
                name: 'Timeline',
                tag: 'pro',
                id: '17287',
            },
            {
                name: 'Unfold',
                tag: 'pro',
                id: '17319',
            },
            {
                name: 'Blog Listing',
                tag: 'freemium',
            },
            {
                name: 'Clients Listing',
                tag: 'freemium',
                id: '17761',
            },
            {
                name: 'Dynamic Listing',
                tag: 'pro',
            },
            {
                name: 'Dynamic Smart Showcase',
                tag: 'pro',
            },
            {
                name: 'Gallery Listing',
                tag: 'freemium',
            },
            {
                name: 'Product Listing',
                tag: 'pro',
            },
            {
                name: 'Team Member Listing',
                tag: 'freemium',
            },
            {
                name: 'Testimonial',
                tag: 'freemium',
            },
            {
                name: 'Search bar',
                tag: 'pro',
            },
            {
                name: 'WP Search Filters',
                tag: 'pro',
            },
            {
                name: 'Social Embed',
            },
            {
                name: 'Social Feed',
                tag: 'pro',
            },
            {
                name: 'Social Icon',
                tag: 'freemium',
                id: '16804',
            },
            {
                name: 'Social Reviews',
                tag: 'pro',
            },
            {
                name: 'Social Sharing',
                tag: 'pro',
                id: '16981',
            },
            {
                name: 'Contact Form 7',
            },
            {
                name: 'Everest Form',
            },
            {
                name: 'Form',
                id: '17282',
            },
            {
                name: 'Gravity Form',
            },
            {
                name: 'Mailchimp',
                tag: 'pro',
            },
            {
                name: 'Meeting Scheduler',
            },
            {
                name: 'Ninja Form',
            },
            {
                name: 'WP Forms',
            },
            // {
            //     name: 'Caldera Forms',
            //     tag: 'Deprecated',
            // },
            {
                name: 'Woo Cart',
                tag: 'pro',
            },
            {
                name: 'Woo Checkout',
                tag: 'pro',
            },
            {
                name: 'Woo Compare',
                tag: 'pro',
            },
            {
                name: 'Woo Wishlist',
                tag: 'pro',
            },
            {
                name: 'WP Quick View',
                tag: 'pro',
            },
            {
                name: 'Woo Multi Step',
                tag: 'pro',
            },
            {
                name: 'Woo My Account',
                tag: 'pro',
            },
            {
                name: 'Woo Order Track',
                tag: 'pro',
            },
            {
                name: 'Woo Single Basic',
                tag: 'pro',
            },
            {
                name: 'Woo Product Images',
                tag: 'pro',
            },
            {
                name: 'Woo Single Pricing',
                tag: 'pro',
            },
            {
                name: 'Woo Single Tabs',
                tag: 'pro',
            },
            {
                name: 'Woo Thank You',
                tag: 'pro',
            },
        ],
        gutenberg: [
            {
                name: 'Pro Buttons',
                tag: 'pro',
                id: '12507',
            },
            {
                name: 'Audio Player',
                id: '11961',
                tag: 'pro'
            },
            {
                name: 'Blockquote',
                id: '11763',
            },
            {
                name: 'Breadcrumbs',
                id: '17677',
            },
            {
                name: 'Advanced Button',
                id: '17180',
            },
            {
                name: 'Read More Unfold Button',
                id: '12221',
                tag: 'pro'
            },
            {
                name: 'Button',
            },
            {
                name: 'Code Highlighter',
                id: '12592'
            },
            {
                name: 'Container',
                id: '11646',
            },
            {
                name: 'Grid Container',
                id: '18285',
            },
            {
                name: 'Coupon Code',
                id: '11983',
                tag: 'pro'
            },
            {
                name: 'Dark Mode',
                tag: 'pro'
            },
            {
                name: 'Design Tool',
                tag: 'pro'
            },
            {
                name: 'Animated SVG',
                id: '11940'
            },
            {
                name: 'Draw SVG',
            },
            {
                name: 'Spacer',
            },
            {
                name: 'Flipbox',
                id: '11758',
                tag: 'freemium'
            },
            {
                name: 'Google Map',
                id: '12120',
                tag: 'freemium'
            },
            {
                name: 'Heading',
            },
            {
                name: 'Icon',
            },
            {
                name: 'Image',
            },
            {
                name: 'Video Gallery',
                id: '18060',
                tag: 'pro'
            },
            {
                name: 'Infobox',
                id: '11315',
            },
            {
                name: 'Login & Signup',
                tag: 'pro'
            },
            {
                name: 'Message box',
                id: '11612'
            },
            {
                name: 'Number Counter',
                id: '12569'
            },
            {
                name: 'Pricing Table',
                id: '11753',
            },
            {
                name: 'Pre Loader',
                tag: 'pro',
                id: '17169',
            },
            {
                name: 'Paragraph',
            },
            {
                name: 'Pro Paragraph',
                id: '11965'
            },
            {
                name: 'Progress Bar',
                id: '17099',
            },
            {
                name: 'Reading Scroll Progress Bar',
                id: '17767',
            },
            {
                name: 'Progress Tracker',
            },
            {
                name: 'Row',
            },
            {
                name: 'Stylish List',
                id: '11494',
            },
            {
                name: 'Search Bar',
            },
            {
                name: 'Social Icon',
            },
            {
                name: 'Smooth Scroll',
            },
            {
                name: 'Table of Content',
                id: '17886',
                tag: 'pro'
            },
            {
                name: 'Video Player',
                id: '11501',
            },
            {
                name: 'Advanced Typography',
                tag: 'pro',
                id: '12372'
            },
            {
                name: 'Animated Service Boxes',
                tag: 'pro',
                id: '12557',
            },
            {
                name: 'Before After',
                id: '17855',
                tag: 'pro'
            },
            {
                name: 'Carousel Anything',
                tag: 'pro',
                id: '11427',
            },
            {
                name: 'Carousel Remote',
                tag: 'pro'
            },
            {
                name: 'Remote Sync',
                id: '12663',
                tag: 'pro'
            },
            {
                name: 'Circle Menu',
                tag: 'pro'
            },
            {
                name: 'Advanced Image',
                id: '17897',
                tag: 'freemium'
            },
            {
                name: 'Data Table',
                tag: 'freemium',
                id: '17220',
            },
            {
                name: 'Dynamic Device',
                tag: 'pro',
                id: '12140'
            },
            {
                name: 'Dynamic Repeater',
                tag: 'pro',
                id: '19472'
            },
            {
                name: 'Expand',
                tag: 'pro'
            },
            {
                name: 'Heading Title',
                id: '12251',
            },
            {
                name: 'Heading Animation',
                tag: 'pro',
                id: '12234',
            },
            {
                name: 'Advanced Heading',
            },
            {
                name: 'Hotspot',
                tag: 'pro',
                id: '11639'
            },
            {
                name: 'Hover Card',
                id: '11375',
            },
            {
                name: 'Section Background',
                id: '17934',
                tag: 'pro'
            },
            {
                name: 'Gallary Background',
                id: '12609',
                tag: 'pro'
            },
            {
                name: 'LottieFiles Animation',
                id: '12085',
                tag: 'pro'
            },
            {
                name: 'Mouse Cursor',
                id: '12178',
                tag: 'pro'
            },
            {
                name: 'Pricing List',
                id: '11716',
            },
            {
                name: 'Process Steps',
                tag: 'pro',
                id: '11691',
            },
            {
                name: 'Scroll Navigation',
                tag: 'pro',
                id: '12210',
            },
            {
                name: 'Scroll Sequence',
                id: '12333',
                tag: 'pro'
            },
            {
                name: 'Spline 3D Viewer',
                tag: 'pro'
            },
            {
                name: 'Timeline',
                id: '11489',
                tag: 'pro'
            },
            {
                name: 'Accordion',
                tag: 'freemium',
                id: '11416'
            },
            {
                name: 'Interactive Circle Info',
                id: '12157',
            },
            {
                name: 'Switcher',
                id: '17920',
                tag: 'freemium'
            },
            {
                name: 'Tabs Tours',
                tag: 'freemium',
                id: '17577',
            },
            {
                name: 'Social Embed',
                tag: 'freemium'
            },
            {
                name: 'Social Feed',
                tag: 'freemium'
            },
            {
                name: 'Social Reviews',
                tag: 'freemium'
            },
            {
                name: 'Advanced Chart',
                id: '12481',
                tag: 'pro'
            },
            {
                name: 'Countdown',
                tag: 'freemium',
                id: '17212'
            },
            {
                name: 'CTA Banner',
                tag: 'pro',
                id: '12009',
            },
            {
                name: 'External Form Styler',
            },
            {
                name: 'Form',
                id: '18484',
                tag: 'freemium'
            },
            {
                name: 'Mailchimp',
                tag: 'pro'
            },
            {
                name: 'Social Sharing',
                tag: 'pro'
            },
            {
                name: 'Media Listing',
                tag: 'pro'
            },
            {
                name: 'Post Listing',
                id: '18099',
                tag: 'freemium'
            },
            {
                name: 'Custom Post Listing',
                id: '18656',
                tag: 'pro'
            },
            {
                name: 'Product Listing',
                id: '18113',
                tag: 'pro'
            },
            {
                name: 'Taxonomy Listing',
                id: '18674',
                tag: 'pro'
            },
            {
                name: 'Glassmorphism',
                id: '19466',
                tag: 'pro'
            },
            {
                name: 'Team Member',
                id: '18006',
                tag: 'freemium'
            },
            {
                name: 'Testimonials',
                id: '18020',
                tag: 'pro'
            },
            {
                name: 'Mega Menu',
                id: '18192',
                tag: 'pro'
            },
            {
                name: 'Mobile Menu',
                tag: 'pro'
            },
            {
                name: 'Navigation Menu',
                tag: 'freemium'
            },
            {
                name: 'Popup Builder',
                id: '18142',
                tag: 'pro'
            },
            {
                name: 'Post Author',
            },
            {
                name: 'Post Comments',
            },
            {
                name: 'Post Content',
            },
            {
                name: 'Post Image',
            },
            {
                name: 'Post Meta Info',
            },
            {
                name: 'Post Navigation',
                tag: 'pro'
            },
            {
                name: 'Post Title',
            },
            {
                name: 'Site Logo',
            },
            {
                name: 'Advanced Border Radius',
                tag: 'pro'
            },
            {
                name: 'Header Effect',
                id: '18180',
                tag: 'pro'
            },
            {
                name: 'Content Hover Effect',
                tag: 'pro'
            },
            {
                name: 'Continuous Animation',
                tag: 'pro'
            },
            {
                name: 'Display Rules',
                tag: 'pro'
            },
            {
                name: 'Equal Column Height',
                tag: 'pro'
            },
            {
                name: 'Global Tooltip',
                tag: 'pro'
            },
            {
                name: 'Magic Scroll',
                tag: 'pro'
            },
            {
                name: 'Mouse Parallax',
                tag: 'pro'
            },
            {
                name: 'On Scroll Animation',
                tag: 'freemium'
            },
            {
                name: '3D Tilt',
                tag: 'pro'
            },
        ]
    };

    /** Plugin Detail for checking TPAE */
    const tpae_plugin_detail = {
        "p_id": 1005,
        "plugin_name": "The Plus Addons for Elementor Free",
        "plugin_slug": "the-plus-addons-for-elementor-page-builder/theplus_elementor_addon.php",
        "original_slug": "the-plus-addons-for-elementor-page-builder",
        "plugin_icon": "https://wdesignkit.com/images/uploads/wpdk-admin/plugin-list/plugin-tpae.svg",
        "freepro": 0,
        "plugin_builder": 1001,
        "type": "plugin",
        "status": "inactive"
    };

    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();
    var img_path = wdkitData.WDKIT_URL;

    const [loader, setLoader] = useState(true);
    const [totalpage, setTotalPage] = useState(1);
    const [IsLoading, setIsLoading] = useState(-1);
    const [MobileFilter, setMobileFilter] = useState(false);
    const [tagList, setTagList] = useState(widget_list?.[wdkitData.use_editor]);
    const [presetField, setPresetField] = useState({
        'type': 'wkit_preset_template',
        'builder': '',
        'plugin': JSON.stringify([]),
        'key_words': JSON.stringify([]),
        'buildertype': window.wdkit_editor,
        'perpage': 9,
        'page': 1,
        'free_pro': 'all',
        'template_id': params?.preset_id,
    });
    const [presetData, setPresetData] = useState(null);
    const [manage_licence, setmanage_licence] = useState([]);
    const [filterLoader, setFilterLoader] = useState(true);
    const [nameMenuToggle, setNameMenuToggle] = useState(false);
    const [presetNameValue, setPresetNameValue] = useState('');
    const [searchValue, setSearchValue] = useState("");
    const [TagSearch, setTagSearch] = useState("");
    const [AccordionOpen, setAccordionOpen] = useState(['status', 'tags', 'she-effects', 'plugins']);
    const [ShowInstallPopup, SetShowInstallPopup] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [sheCheck, setSheCheck] = useState(false);
    const [check_pro, setcheck_pro] = useState('');
    const [showTpaePopup, setshowTpaePopup] = useState(false);
    const [shePopuptype, setshePopuptype] = useState('');
    const [currSheInfo, setCurrSheInfo] = useState({ 'preset': null, 'key': null });

    const she_plugins = useRef([]);

    let filterItem = [{ label: __('Free', 'wdesignkit'), value: 'Free' }, { label: __('Pro', 'wdesignkit'), value: 'Pro' }],
        CheckIcon = (<svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 0C6.15661 -9.78424e-09 6.80679 0.129329 7.41342 0.380602C8.02004 0.631876 8.57124 1.00017 9.03553 1.46447C9.49983 1.92876 9.86812 2.47995 10.1194 3.08658C10.3707 3.69321 10.5 4.34339 10.5 5C10.5 5.65661 10.3707 6.30679 10.1194 6.91342C9.86812 7.52004 9.49983 8.07124 9.03553 8.53553C8.57124 8.99983 8.02004 9.36812 7.41342 9.6194C6.80679 9.87067 6.15661 10 5.5 10C4.17392 10 2.90215 9.47322 1.96447 8.53553C1.02678 7.59785 0.5 6.32608 0.5 5C0.5 3.67392 1.02678 2.40215 1.96447 1.46447C2.90215 0.526784 4.17392 1.97602e-08 5.5 0ZM7.26667 3.47L4.875 5.86833L3.71167 4.705C3.67293 4.66626 3.62694 4.63553 3.57632 4.61456C3.5257 4.5936 3.47145 4.58281 3.41667 4.58281C3.36188 4.58281 3.30763 4.5936 3.25701 4.61456C3.2064 4.63553 3.16041 4.66626 3.12167 4.705C3.08293 4.74374 3.0522 4.78973 3.03123 4.84035C3.01026 4.89096 2.99947 4.94521 2.99947 5C2.99947 5.05479 3.01026 5.10904 3.03123 5.15965C3.0522 5.21027 3.08293 5.25626 3.12167 5.295L4.58 6.75333C4.6187 6.79214 4.66468 6.82292 4.71531 6.84393C4.76593 6.86493 4.82019 6.87574 4.875 6.87574C4.92981 6.87574 4.98407 6.86493 5.03469 6.84393C5.08532 6.82292 5.1313 6.79214 5.17 6.75333L7.85667 4.05833C7.93246 3.97964 7.97432 3.87433 7.97322 3.76508C7.97212 3.65583 7.92815 3.55138 7.85078 3.47423C7.77342 3.39709 7.66884 3.35341 7.55959 3.35262C7.45034 3.35183 7.34514 3.39398 7.26667 3.47Z" fill="white" /></svg>),
        elementor_poup_accordian = [
            {
                question: __('Why Do I Need to Upgrade to The Plus Addons for Elementor Pro?', 'wdesignkit'),
                answer: __('The Plus Addons for Elementor offers both Free and Pro plans. To ensure quality design and better results, our premium plan provides full access to advanced features that make your web design process easier. We promise it\'s worth it!For any questions, connect with us via our website live chat—we\'ll get back to you soon.', 'wdesignkit'),
            }
        ],
        nexter_poup_accordian = [
            {
                question: __('Why Do I Need to Upgrade to Nexter Blocks Pro?', 'wdesignkit'),
                answer: __('Nexter Blocks offers both Free and Pro plans. To ensure quality design and better results, our premium plan provides full access to advanced features that make your web design process easier. We promise it\'s worth it!For any questions, connect with us via our website live chat—we\'ll get back to you soon.', 'wdesignkit'),
            }
        ],
        tpae_poup_accordian = [
            {
                question: __('Why Do I Need The Plus Addons for Elementor?', 'wdesignkit'),
                answer: __('The Elementor Free version does not come with a free Navigation Menu widget. Therefore, by installing The Plus Addons, you can create your Header Menu easily.', 'wdesignkit'),
            }
        ],
        elementor_pro_popup_accordian = [
            {
                question: __('Why do I need Elementor Pro for this Template?', 'wdesignkit'),
                answer: __('This sticky header template is built using Elementor Pro\'s Navigation Menu widget, which is only available with the Pro version. To use this template and unlock its full potential, you\'ll need to have Elementor Pro installed and activated.', 'wdesignkit'),
            }
        ];

    const getBaseUrl = () => {
        const url = window.location.href;
        const pathParts = url.split("/wp-admin/");
        return pathParts[0] + "/wp-admin/";
    };

    const checkProPlugin = async () => {
        let ele_pro = {
            plugin_name: "Elementor Pro",
            plugin_slug: "elementor-pro/elementor-pro.php",
            original_slug: "elementor-pro",
            status: "inactive",
            type: "plugin",
        };

        let elementorPro = await check_active_plugins([ele_pro]);
        var updatePlugin = { ...presetField, 'plugin': JSON.stringify([1014, 1003]), 'free_pro': 'free' }
        if (elementorPro?.data?.plugins[0].status == 'active') {
            updatePlugin = { ...presetField, 'plugin': JSON.stringify([1014, 1004]) }
        }

        setPresetField(updatePlugin);
        setcheck_pro(true);
    }

    /** Function which handles Preset Name on Loading comp first time */
    useEffect(() => {
        var stickyCheck = false;
        let id = params?.preset_id,
            name = widget_list?.[wdkitData?.use_editor]?.find((item) => { return item?.id == id })?.name;

        if (name) {
            setPresetNameValue(name);
        }

        if (location.search) {
            const queryParams = new URLSearchParams(location.search);
            stickyCheck = queryParams.get('she');
            if (stickyCheck) {
                setSheCheck(true);
            }
        }

        if (!stickyCheck) {
            if ('gutenberg' === wdkitData?.use_editor) {
                setcheck_pro(tpgb_blocks_load?.nexter_block_pro);
            } else if ('elementor' === wdkitData?.use_editor) {
                setcheck_pro(tp_wdkit_preview_popup?.tpae_pro);
            }
        } else {
            checkProPlugin();
        }
    }, [])

    useEffect(() => {
        handlePresetAPI()
    }, [presetField]);

    /**Function for calling Preset API */
    const handlePresetAPI = async () => {

        if (controller) {
            controller.abort();
        }

        controller = new AbortController();

        let form = new FormData();
        form.append('action', 'get_wdesignkit');
        form.append('kit_nonce', wdkitData.kit_nonce);

        Object.entries(presetField).forEach(([key, value]) => {
            if (key === 'free_pro' && value === 'all') {
                form.append(key, "");
            } else {
                form.append(key, value);
            }
        })

        await axios.post(wdkitData.ajax_url, form, { signal: controller.signal }).then((result) => {

            if (result?.data) {
                let resultData = result?.data?.data;
                setmanage_licence(result?.data?.manage_licence);
                setTotalPage(result?.data?.totalpage);
                setPresetData(resultData);
                setLoader(false);
                setFilterLoader(false);
            } else {
                setPresetData(null);
            }
        });

    }

    /**function for Setting Image URL */
    const SetImageUrl = (url) => {
        if (url) {
            var imageUrl = url.replace(/\s/g, "%20");

            return imageUrl;
        } else {
            return img_path + 'assets/images/placeholder.jpg';
        }
    }


    /** Function for Preset Skeleton */
    const PresetSkeleton = (number) => {

        /** get array of required length */
        const getArray = (length) => Array.from({ length });
        if (number) {

            return (
                <>
                    {getArray(number).map((data, index) => (
                        <div className="wkit-preset-card" key={index}>
                            <div className="wkit-card-inner">
                                <div className="wkit-pr-card-top">
                                    <div className="wkit-preset-feature-img">
                                        <img className="wkit-widget-placeholder-img" src={img_path + 'assets/images/wkit-dummy-bg.png'} draggable="false" />
                                    </div>
                                </div>
                                <div className="wkit-preset-card-bottom">
                                    <div className="wkit-pr-card-title">Growth Metrics</div>
                                    <div className="wkit-preset-download-btn">
                                        <div className="preset-download-temp">
                                            <img className="wkit-preset-download-icon" src={img_path + "assets/images/svg/popup-download.svg"} alt="view-kit" draggable="false" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </>

            )

        }

    }

    /** Function for checking if the TPAE is active or not */
    const check_tpae_plugin = (preset, key) => {
        if (she_plugins.current.length > 0 && preset.plugins_id.includes(she_plugins.current[0]?.p_id)) {
            SetShowInstallPopup(true);
            setshowTpaePopup(true);
            setshePopuptype(she_plugins.current[0].original_slug)
            setCurrSheInfo(prevData => ({
                ...prevData,
                'preset': preset,
                'key': key,
            }));
        } else {
            SetShowInstallPopup(false);
            setshowTpaePopup(false);
            handlePresetDownload(preset, key)
        }
    }

    const import_preset = (preset, key) => {
        if (sheCheck == true) {
            check_tpae_plugin(preset, key)
        } else {
            SetShowInstallPopup(true);
        }
    }

    const Download_preset_btn = (preset, key) => {
        var pro_temp = true;
        var elementor_lcs = false;
        var gutenberg_lcs = false;

        if (window.wdkit_editor == 'elementor' && manage_licence?.['theplus_elementor_addon'] && check_pro === '1') {
            elementor_lcs = true;
        }

        if (window.wdkit_editor == 'gutenberg' && manage_licence?.tpag && check_pro === '1') {
            gutenberg_lcs = true;
        }

        if (sheCheck == true) {
            if (preset.plugins_id?.length > 0) {
                let pro_check = []
                preset.plugins_id.map((id) => {
                    if (id != '1003' && id != '1014') {
                        let plugin_array = props.wdkit_meta?.plugin?.length > 0 ? props.wdkit_meta?.plugin : [];

                        let index = plugin_array.findIndex((plugin) => plugin.p_id == id)
                        if (index > -1) {
                            let slug = plugin_array[index].original_slug;

                            if (!(manage_licence?.[slug])) {
                                pro_check.push(plugin_array[index]);
                            }
                        }
                    }
                })

                if (pro_check?.length == 0) {
                    pro_temp = false;
                } else {
                    she_plugins.current = pro_check;
                }
            }
        } else {
            if (preset?.free_pro == 'free') {
                pro_temp = false;
            } else if (gutenberg_lcs || elementor_lcs) {
                pro_temp = false;
            } else {
                pro_temp = true;
            }
        }

        if (pro_temp) {
            return (
                <div className='wkit-preset-download-btn wkit-lock-btn' onClick={() => { import_preset(preset, key) }}>
                    <span className='wkit-preset-tooltip'>{__('Click to know more', 'wdesignkit')}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M10.0625 5.25V3.81063C10.0613 3.0324 9.75168 2.28639 9.2014 1.7361C8.65111 1.18582 7.9051 0.876157 7.12688 0.875H6.87313C6.0949 0.876157 5.34889 1.18582 4.7986 1.7361C4.24832 2.28639 3.93866 3.0324 3.9375 3.81063V5.25C3.5894 5.25 3.25556 5.38828 3.00942 5.63442C2.76328 5.88056 2.625 6.2144 2.625 6.5625V10.6312C2.62616 11.2923 2.88926 11.9259 3.35668 12.3933C3.8241 12.8607 4.45772 13.1238 5.11875 13.125H8.88125C9.54228 13.1238 10.1759 12.8607 10.6433 12.3933C11.1107 11.9259 11.3738 11.2923 11.375 10.6312V6.5625C11.375 6.2144 11.2367 5.88056 10.9906 5.63442C10.7444 5.38828 10.4106 5.25 10.0625 5.25ZM4.8125 3.81063C4.8125 3.26411 5.0296 2.73999 5.41604 2.35354C5.80249 1.9671 6.32661 1.75 6.87313 1.75H7.12688C7.67339 1.75 8.19752 1.9671 8.58396 2.35354C8.9704 2.73999 9.1875 3.26411 9.1875 3.81063V5.25H4.8125V3.81063Z" fill="#727272" />
                        <path d="M7.4375 9.0649V10.4999C7.4375 10.6159 7.39141 10.7272 7.30936 10.8093C7.22731 10.8913 7.11603 10.9374 7 10.9374C6.88397 10.9374 6.77269 10.8913 6.69064 10.8093C6.60859 10.7272 6.5625 10.6159 6.5625 10.4999V9.0649C6.39569 8.96859 6.26532 8.81993 6.19161 8.64198C6.11789 8.46402 6.10496 8.26672 6.15482 8.08066C6.20467 7.89461 6.31452 7.7302 6.46733 7.61294C6.62015 7.49569 6.80738 7.43213 7 7.43213C7.19262 7.43213 7.37985 7.49569 7.53267 7.61294C7.68548 7.7302 7.79533 7.89461 7.84519 8.08066C7.89504 8.26672 7.88211 8.46402 7.8084 8.64198C7.73468 8.81993 7.60431 8.96859 7.4375 9.0649Z" fill="#D1D1D6" />
                    </svg>
                </div>
            );
        }

        if (IsLoading == key) {
            return (
                <div className='wkit-preset-download-btn wkit-loading-preset'>
                    <div className="wkit-publish-loader">
                        <div className="wb-loader-circle"></div>
                    </div>
                </div>
            );
        } else if (IsLoading !== -1) {
            return (
                <div className='wkit-preset-download-btn wkit-disable-btn'>
                    <img className='wkit-preset-download-icon' src={img_path + "assets/images/svg/popup-download.svg"} alt="view-kit" draggable={false} />
                </div>
            );
        } else {
            if (sheCheck == true) {
                return (
                    <div className='wkit-preset-download-btn' onClick={() => {
                        check_tpae_plugin(preset, key)
                    }}>
                        <img className='wkit-preset-download-icon' src={img_path + "assets/images/svg/popup-download.svg"} alt="view-kit" draggable={false} />
                    </div>
                );
            } else {
                return (
                    <div className='wkit-preset-download-btn' onClick={() => handlePresetDownload(preset, key)}>
                        <img className='wkit-preset-download-icon' src={img_path + "assets/images/svg/popup-download.svg"} alt="view-kit" draggable={false} />
                    </div>
                );
            }
        }
    }

    const handlePresetDownload = async (preset, key) => {
        setIsLoading(key);

        if (controller) {
            controller.abort();
        }

        controller = new AbortController();

        let form = new FormData();
        form.append('action', 'get_wdesignkit');
        form.append('kit_nonce', wdkitData.kit_nonce);
        form.append('type', 'wdkit_preset_dwnld_template');
        form.append('id', preset?.id);
        form.append('builder', window.wdkit_editor);
        form.append('free_pro', preset?.free_pro);
        form.append('sheCheck', sheCheck);
        form.append('product_name', '');

        let rseponse = await axios.post(wdkitData.ajax_url, form, { signal: controller.signal }).then((res) => res.data);

        if (rseponse?.success) {
            let tempContent = JSON.parse(rseponse.content);

            if (tempContent && tempContent.content && wdkitData.use_editor == 'gutenberg') {
                let blocks = wp.blocks.parse(tempContent.content);
                let session_data = sessionStorage?.getItem('tpgb_wkit_preset_key');

                await set_nexter_widgets(tempContent.content);

                //Media Import 
                let blocks_str = JSON.stringify(blocks);
                if (/\.(jpg|png|jpeg|gif|svg|webp)/gi.test(blocks_str)) {
                    let form_arr = { 'type': 'media_import', 'content': blocks_str, 'editor': wdkitData.use_editor };
                    let media_res = await wdKit_Form_data(form_arr);

                    if (media_res.data && media_res.success) {
                        blocks = media_res.data;

                        const selectedBlock = wp.data.select('core/block-editor').getSelectedBlock();

                        if (selectedBlock && session_data) {
                            wp.data.dispatch('core/block-editor').removeBlock(selectedBlock.clientId);
                            wp.data.dispatch('core/block-editor').insertBlocks(blocks, selectedBlock.clientId);
                        } else {
                            wp.data.dispatch('core/block-editor').insertBlocks(blocks);
                        }
                        sessionStorage.removeItem('tpgb_wkit_preset_key');
                    }
                } else {
                    const selectedBlock = wp.data.select('core/block-editor').getSelectedBlock();

                    if (selectedBlock && session_data) {
                        await wp.data.dispatch('core/block-editor').removeBlock(selectedBlock.clientId);
                        await wp.data.dispatch('core/block-editor').insertBlocks(blocks, selectedBlock.clientId);
                    } else {
                        await wp.data.dispatch('core/block-editor').insertBlocks(blocks);
                    }
                    sessionStorage.removeItem('tpgb_wkit_preset_key');
                }

                props.wdkit_set_toast([__('Widget Preset Imported Successfully!', 'wdesignkit'), __(' Enjoy customizing your design in Gutenberg!', 'wdesignkit'), '', 'success']);

                setTimeout(async () => {

                    let gut_doc = document.querySelector('#wkit-builder-modal');
                    if (gut_doc) {
                        gut_doc.classList.toggle("wkit-open");
                        window.location.hash = '';
                    }

                    await wp.data.dispatch('core/editor').savePost();
                    window.location.reload();
                }, 1500);

                setIsLoading(-1);

                return () => {
                    clearTimeout(timeId)
                }
            } else if (tempContent && tempContent.content && tempContent.file_type == 'elementor' && wdkitData.use_editor == 'elementor') {
                await get_widget_list(tempContent);
                await checkPlugin_widget();

                let content_str = JSON.stringify(tempContent.content);
                if (/\.(jpg|png|jpeg|gif|svg|webp)/gi.test(content_str)) {
                    let form_arr = { 'type': 'media_import', 'email': '', 'content': content_str, 'editor': wdkitData.use_editor }
                    let media_res = await wdKit_Form_data(form_arr);
                    if (media_res.data && media_res.success) {
                        tempContent.content = media_res.data
                    }
                }

                var win_ele = window.elementor,
                    win_el = $e;
                if (win_ele) {
                    if (undefined !== win_el) {
                        function ele_uniqueID(a) {
                            return (
                                a.forEach(function (a) {
                                    (a.id = elementorCommon.helpers.getUniqueId()), 0 < a.elements.length && ele_uniqueID(a.elements);
                                }),
                                a
                            );
                        }
                        for (var i = 0; i < tempContent.content.length; i++) {
                            var sec = { elType: tempContent.content[i].elType, settings: tempContent.content[i].settings };
                            sec.elements = ele_uniqueID(tempContent.content[i].elements)
                            win_el.run("document/elements/create", {
                                container: win_ele.getPreviewContainer(),
                                model: sec,
                                options: {
                                    index: 0
                                }
                            });
                        }
                    } else {
                        var model = new Backbone.Model({
                            getTitle: function () {
                                return "Wdesignkit Import"
                            }
                        });
                        win_el.channels.data.trigger("template:before:insert", model);
                        for (var i = 0; i < tempContent.content.length; i++) win_el.getPreviewView().addChildElement(tempContent.content[i], {
                            index: 0
                        });
                        win_el.channels.data.trigger("template:after:insert", {})
                    }

                    elementor.saver.update.apply().then(function () {
                        window.location.reload();
                    });

                    props.wdkit_set_toast([__('Widget Preset Imported Successfully!', 'wdesignkit'), __(' Enjoy customizing your design in Elementor!', 'wdesignkit'), '', 'success']);

                    setTimeout(() => {
                        var event = window?.WdkitPopup?.getElements("content");
                        if (event) {
                            window.WdkitPopupToggle.close(event.get(0)), window.WdkitPopup.destroy()
                        }

                        var event = window?.She_WdkitPopup?.getElements("content");
                        if (event) {
                            window.WdkitPopupToggle.close(event.get(0)), window.She_WdkitPopup.destroy()
                        }
                    }, 1500);
                    setIsLoading(-1);

                    return () => {
                        clearTimeout(timeId)
                    }
                }
            } else {
                setIsLoading(-1);
            }
        } else {
            props.wdkit_set_toast([rseponse.message, rseponse.description, '', 'danger']);
            setIsLoading(-1);
        }
    }

    /** Function for Preset Cards */
    const PresetCard = (key, preset) => {

        return (
            <div className='wkit-preset-card' key={key}>
                <div className='wkit-card-inner'>
                    <div className='wkit-pr-card-top' onClick={() => window.open(preset?.post_url, '_blank')} >
                        <div className='wkit-preset-card-tag'>
                            <span>{preset?.free_pro}</span>
                        </div>
                        <div className='wkit-preset-feature-img'>
                            <img className="wkit-widget-placeholder-img" src={img_path + 'assets/images/wkit-dummy-bg.png'} draggable="false" />
                            <picture>
                                {preset?.responsive_image?.length > 0 && preset?.responsive_image.map((image_data, index) => {
                                    return (
                                        <Fragment key={index}>
                                            <source media={`(min-width: ${image_data?.size}px)`} srcSet={SetImageUrl(image_data?.url)} />
                                        </Fragment>
                                    );
                                })
                                }
                                <img className='wkit-temp-image-content' src={preset?.post_image} alt={"featured-img"} draggable={false} />
                            </picture>
                            <div className='wkit-preset-preview'>
                                <div className='wkit-preset-demo-inner'>
                                    <div className='wkit-preview-items'>
                                        <svg width="17" height="17" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.51293 6.58874C8.51293 7.60786 7.6894 8.43139 6.67028 8.43139C5.65117 8.43139 4.82764 7.60786 4.82764 6.58874C4.82764 5.56962 5.65117 4.74609 6.67028 4.74609C7.6894 4.74609 8.51293 5.56962 8.51293 6.58874Z" stroke="#FFFFFF" strokeWidth="1.23529" strokeLinecap="round" strokeLinejoin="round" /><path d="M6.67019 10.8455C8.4871 10.8455 10.1805 9.77494 11.3592 7.922C11.8224 7.19627 11.8224 5.97641 11.3592 5.25068C10.1805 3.39774 8.4871 2.32715 6.67019 2.32715C4.85328 2.32715 3.15989 3.39774 1.98122 5.25068C1.51798 5.97641 1.51798 7.19627 1.98122 7.922C3.15989 9.77494 4.85328 10.8455 6.67019 10.8455Z" stroke="#FFFFFF" strokeWidth="1.23529" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                        <span>{__('View Demo', 'wdesignkit')}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='wkit-preset-card-bottom'>
                        <div className='wkit-pr-card-title'>{preset?.title}</div>
                        {Download_preset_btn(preset, key)}
                    </div>
                </div>
            </div>
        );
    }

    /** Function which runs  when we select or filter anything */
    const handlePresetFilterSelection = (selected, value) => {
        setLoader(true);

        if (selected == 'search') {
            var updated_object = Object.assign({}, presetField, { 'search': value, 'page': 1 });
        } else if (selected == 'filterItem' && value != '') {
            var selectedFilterItem = value.toLowerCase(),
                filter_type = 'all';

            if (presetField.free_pro !== selectedFilterItem) {
                filter_type = selectedFilterItem;
            }

            var updated_object = Object.assign({}, presetField, { 'free_pro': filter_type, 'page': 1 });
        } else if (selected == 'filterName') {
            var updated_object = Object.assign({}, presetField, { 'template_id': value.id, 'page': 1 });
            setPresetNameValue(value.presetName);
            nameMenuToggle == true ? setNameMenuToggle(false) : setNameMenuToggle(true);
        } else if (selected == 'plugin') {
            let p_array,
                pluginList = (presetField?.plugin && !Array.isArray(presetField?.plugin)) ? JSON.parse(presetField?.plugin) : [];

            if (sheCheck && !pluginList?.includes(1014)) {
                pluginList.push(1014);
            }

            if (pluginList?.includes(value)) {
                p_array = pluginList.filter((item) => item !== value);
            } else {
                p_array = [...pluginList, value];
            }

            var updated_object = { ...presetField, 'plugin': JSON.stringify(p_array), 'page': 1 };
        } else if (selected == 'key_words') {
            let keyWords_array,
                keyWords_list = (presetField?.key_words && !Array.isArray(presetField?.key_words)) ? JSON.parse(presetField?.key_words) : [];

            if (keyWords_list?.includes(value)) {
                keyWords_array = keyWords_list.filter((item) => item !== value);
            } else {
                keyWords_array = [...keyWords_list, value];
            }

            var updated_object = { ...presetField, 'key_words': JSON.stringify(keyWords_array), 'page': 1 };
        }

        setPresetField(updated_object);
    }

    /**Preset Pagination */
    const Pagaination = () => {
        if (presetData?.length > 0 && totalpage > 1) {
            return (

                <div className='wkit-pagination-main'>
                    <ReactPaginate
                        breakLabel={"..."}
                        nextLabel={<svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none"><path d="M0.412598 9.52417L4.48371 5.44417L0.412598 1.36417L1.66593 0.11084L6.99926 5.44417L1.66593 10.7775L0.412598 9.52417Z" fill="#8991A4" /></svg>}
                        pageRangeDisplayed={2}
                        pageCount={totalpage}
                        marginPagesDisplayed={1}
                        previousLabel={<svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11" fill="none"><path d="M7.47754 1.36352L3.40643 5.44352L7.47754 9.52352L6.22421 10.7769L0.890873 5.44352L6.22421 0.110189L7.47754 1.36352Z" fill="#8991A4" /></svg>}
                        pageClassName={"wkit-page-item"}
                        pageLinkClassName={"wkit-pagination-item"}
                        previousClassName={"wkit-next-prev wkit-prev-pagination"}
                        previousLinkClassName={"wkit-pagination-item"}
                        nextClassName={"wkit-next-prev wkit-next-pagination"}
                        nextLinkClassName={"wkit-pagination-item"}
                        breakClassName={"wkit-page-item"}
                        breakLinkClassName={"page-link"}
                        containerClassName={"wkit-pagination"}
                        activeClassName={"active"}
                        onClick={(clickEvent) => {
                            window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: 'smooth'
                            });
                            if (clickEvent.nextSelectedPage != undefined) {
                                presetField['page'] = (clickEvent.nextSelectedPage + 1);
                                setPresetField({ ...presetField });
                                setLoader(true);
                            }
                        }}
                        forcePage={presetField.page - 1}
                        onPageActive={() => { }}
                    />
                </div>
            );
        }
    }

    const checkAccordion = (type) => {
        let updatedAccordionOpen = [...AccordionOpen];

        if (updatedAccordionOpen.includes(type)) {
            updatedAccordionOpen = updatedAccordionOpen.filter((item) => item !== type);
        } else {
            updatedAccordionOpen.push(type);
        }

        setAccordionOpen(updatedAccordionOpen);
    }

    /** Filter for All , Free and Pro Display*/
    const FreePro_filter = () => {
        return (
            <div className='wkit-preset-filter-container'>
                <div className='wkit-preset-accordian' onClick={() => { checkAccordion('status') }}>
                    <span className='wkit-preset-heading'>{__('Status', 'wdesignkit')}</span>
                    <svg className={`wkit-acc-svg ${AccordionOpen.includes('status') ? '' : 'wkit-rotate-icon'}`} width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 8.75L7 5.25L3.5 8.75" stroke="#020202" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                {AccordionOpen.includes('status') &&
                    <div className='wkit-preset-free-pro'>
                        {filterItem.map((item, index) => {
                            return (
                                <label htmlFor={`wkit-preset-${item?.value}`} key={index} className='wkit-preset-freePro'>
                                    <input
                                        className='wkit-check-box'
                                        onChange={(e) => handlePresetFilterSelection('filterItem', item?.value)}
                                        type='checkbox'
                                        id={`wkit-preset-${item?.value}`}
                                        checked={presetField?.free_pro === item?.value?.toLowerCase() ? true : false}
                                    />
                                    <span>{item.label}</span>
                                </label>
                            )
                        })}
                    </div>
                }
            </div>
        )
    }

    /** Filter for Preset Name */
    const Preset_tag_filter = () => {
        const handleMenuClick = (id, name) => {
            navigate('/preset/' + id);
            handlePresetFilterSelection('filterName', { id: id, presetName: name });
        }

        const Search_Tag = (value) => {
            setTagSearch(value);
            if (value.trim() == '') {
                var Searched_tag = widget_list?.[wdkitData.use_editor];
            } else {
                var Searched_tag = widget_list?.[wdkitData.use_editor]?.filter((data) => data.name.toLowerCase().includes(value.toLocaleLowerCase()))
            }
            setTagList(Searched_tag);
        }

        return (
            <div className='wkit-preset-tag-container'>
                <div className='wkit-preset-accordian' onClick={() => { checkAccordion('tags') }}>
                    <span className='wkit-preset-heading'>{getFilterHeading()}</span>
                    <svg className={`wkit-acc-svg ${AccordionOpen.includes('tags') ? '' : 'wkit-rotate-icon'}`} width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 8.75L7 5.25L3.5 8.75" stroke="#020202" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>

                </div>
                {AccordionOpen?.includes('tags') &&
                    <>
                        <div className='wkit-browse-search-inner'>
                            <input
                                className='wkit-browse-search'
                                placeholder={__('Search', 'wdesignkit')}
                                type="text"
                                value={TagSearch}
                                onChange={(e) => { Search_Tag(e.target.value); }}
                            />
                        </div>
                        {tagList?.length > 0 &&
                            <div className='wkit-preset-tags'>
                                {tagList?.map((data, index) => {
                                    let id = data.name.split(' ').join('-');
                                    return (
                                        <div className={`wkit-preset-tag-data ${data.id ? '' : 'wkit-disable-btn-class'}`} key={index}>
                                            <label className={`wkit-preset-tag-name ${data.id ? '' : 'wdkit-diabled-element'}`} htmlFor={`wkit-preset-${id}`}>
                                                <input type='radio'
                                                    checked={presetNameValue === data.name ? true : false}
                                                    className={`wkit-radio-button`}
                                                    onChange={() => handleMenuClick(data?.id, data.name)} id={`wkit-preset-${id}`}
                                                />
                                                {data.name}
                                            </label>
                                            {data?.tag && data?.id &&
                                                <span className={`wkit-preset-tag-type ${data?.tag === 'pro' ? 'wkit-preset-pro' : ''}`}>{data?.tag}</span>
                                            }
                                            {!data?.id &&
                                                <span className='wkit-preset-tag-type wkit-preset-comingSoon'>{__('Coming Soon', 'wdesignkit')}</span>
                                            }
                                        </div>
                                    )
                                })}
                            </div>
                        }
                    </>
                }
            </div>
        )
    }

    const Sticky_header_filter = () => {

        let effect_array = [
            { label: __('Header Scroll Distance', 'wdesignkit'), id: 'header-scroll-distance', value: 'Header Scroll Distance' },
            { label: __('Transparent Header Background', 'wdesignkit'), id: 'transparent-header-background', value: 'Transparent Header Background' },
            { label: __('Background Color Change', 'wdesignkit'), id: 'background-color-change', value: 'Background Color Change' },
            { label: __('Bottom Border Styling', 'wdesignkit'), id: 'bottom-border-styling', value: 'Bottom Border Styling' },
            { label: __('Header Shrinking', 'wdesignkit'), id: 'header-shrinking', value: 'Header Shrinking' },
            { label: __('Logo Shrinking', 'wdesignkit'), id: 'logo-shrinking', value: 'Logo Shrinking' },
            { label: __('Logo Color Change', 'wdesignkit'), id: 'logo-color-change', value: 'Logo Color Change' },
            { label: __('Blur Background', 'wdesignkit'), id: 'blur-background', value: 'Blur Background' },
            { label: __('Hide Header on Scroll Down', 'wdesignkit'), id: 'hide-header-on-scroll-down', value: 'Hide Header on Scroll Down' },
            { label: __('Above Header Section', 'wdesignkit'), id: 'above-header-section', value: 'Above Header Section' },
        ],
            plugin_array = [
                { label: __('Elementor', 'wdesignkit'), id: 'elementor', p_id: 1003, icon: 'https://wdesignkit.com/images/uploads/wpdk-admin/plugin-list/plugin-elementor.svg' },
                { label: __('Elementor Pro', 'wdesignkit'), id: 'elementor-pro', p_id: 1004, icon: 'https://wdesignkit.com/images/uploads/wpdk-admin/plugin-list/plugin-elementor-pro.svg' },
                { label: __('The Plus Addons For Elementor', 'wdesignkit'), id: 'tpae', p_id: 1005, icon: 'https://wdesignkit.com/images/uploads/wpdk-admin/plugin-list/plugin-tpae.svg' },
                { label: __('The Plus Addons For Elementor Pro', 'wdesignkit'), id: 'tpae-pro', p_id: 1006, icon: 'https://wdesignkit.com/images/uploads/wpdk-admin/plugin-list/plugin-tpae-pro.svg' },
                { label: __('Sticky Header Effects For Elementor', 'wdesignkit'), id: 'she', p_id: 1014, icon: 'https://wdesignkit.com/images/uploads/wpdk-admin/plugin-list/sticky-header-effects-for-elementor.svg' },
            ],
            check_p_array = presetField?.plugin && !Array.isArray(presetField?.plugin) ? JSON.parse(presetField?.plugin) : [],
            key_word_include = presetField?.key_words && !Array.isArray(presetField?.key_words) ? JSON.parse(presetField?.key_words) : [];

        return (
            <>
                <div className='wkit-preset-filter-container'>
                    <div className='wkit-preset-accordian' onClick={() => { checkAccordion('she-effects') }}>
                        <span className='wkit-preset-heading'>{__('Header Effects', 'wdesignkit')}</span>
                        <svg className={`wkit-acc-svg ${AccordionOpen.includes('she-effects') ? '' : 'wkit-rotate-icon'}`} width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.5 8.75L7 5.25L3.5 8.75" stroke="#020202" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    {AccordionOpen?.includes('she-effects') &&
                        <div className='wkit-preset-effects-container'>
                            {effect_array?.map((data, index) => {
                                return (
                                    <label className='wkit-preset-cb-label' htmlFor={data.id} key={index}>
                                        <input
                                            type='checkbox'
                                            className='wkit-check-box'
                                            onChange={() => handlePresetFilterSelection('key_words', data?.value)}
                                            checked={key_word_include?.includes(data?.value) ? true : false}
                                            id={data.id}
                                        />
                                        <span className='wkit-cb-label'>{data.label}</span>
                                    </label>
                                )
                            })}
                        </div>
                    }
                </div>

                <hr className='wkit-preset-line' />

                <div className='wkit-preset-filter-container'>
                    <div className='wkit-preset-accordian' onClick={() => { checkAccordion('plugins') }}>
                        <span className='wkit-preset-heading'>{__('Plugins', 'wdesignkit')}</span>
                        <svg className={`wkit-acc-svg ${AccordionOpen.includes('plugins') ? '' : 'wkit-rotate-icon'}`} width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.5 8.75L7 5.25L3.5 8.75" stroke="#020202" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    {AccordionOpen?.includes('plugins') &&
                        <div className='wkit-preset-effects-container'>
                            {plugin_array?.map((data, index) => {
                                return (
                                    <label className={`wkit-preset-cb-label ${data?.p_id === 1014 ? 'wkit-disable-btn-class' : ''}`} htmlFor={data.id} key={index}>
                                        <input
                                            type='checkbox'
                                            className='wkit-check-box'
                                            checked={check_p_array?.includes(data?.p_id) ? true : false}
                                            disabled={data.p_id === 1014 ? true : false}
                                            onChange={() => handlePresetFilterSelection('plugin', data?.p_id)}
                                            id={data.id}
                                        />
                                        <img className='wkit-preset-plugin-img' src={data.icon} alt={data.label} />
                                        <span className='wkit-cb-label'>{data.label}</span>
                                    </label>
                                )
                            })}
                        </div>
                    }
                </div>
            </>
        )
    }

    /**Filter for Search Menu */
    const PresetSearchfilter = () => {

        const handleKeyPress = (e) => {
            if ('Enter' === e.key) {
                handlePresetFilterSelection('search', searchValue);
            }
        };

        return (
            <div className='wkit-preset-search-template'>
                <div className='wkit-search-filter'>
                    <div className='wkit-browse-search-inner'>
                        <input
                            className='wkit-browse-search'
                            placeholder={__('Search Presets', 'wdesignkit')}
                            type="text"
                            value={searchValue}
                            onChange={(e) => {
                                setSearchValue(e.target.value)
                            }}
                            onKeyDown={handleKeyPress}
                        />
                        <span className="wkit-search-button wkit-btn-class" onClick={(e) => { handlePresetFilterSelection('search', searchValue) }} >
                            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" fill="none"><path d="M14.4299 5.92969L20.4999 11.9997L14.4299 18.0697" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" /><path d="M3.5 12H20.33" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        </span>
                    </div>
                </div>
            </div>
        )
    }

    const Close_popup = (e) => {
        if ((e.target.closest('.wkit-overlay') && !e.target.closest('.tpae-nexter-bg')) || e.target.closest('.tpae-model-close')) {
            if (showTpaePopup == true) {
                setshowTpaePopup(false);
                SetShowInstallPopup(false);
            } else {
                SetShowInstallPopup(false);
            }
        }
    }

    const getFilterHeading = () => {
        if ('elementor' === wdkitData?.use_editor) {
            if (sheCheck) {
                return __('Header Effects', 'wdesignkit');
            } else {
                return __('Elementor Widgets', 'wdesignkit');
            }
        } else if ('gutenberg' === wdkitData?.use_editor) {
            return __('Gutenberg Blocks', 'wdesignkit');
        } else {
            return __('Widget Presets', 'wdesignkit');
        }
    }

    const PresetFilterPanel = () => {

        return (
            <div className='wkit-preset-filter-content' style={{ minHeight: MobileFilter ? '100%' : 'auto' }}>
                <div className='wkit-search-filter-content'>
                    <span className='wkit-preset-heading'>{__('Search Presets', 'wdesignkit')}</span>
                    {PresetSearchfilter()}
                </div>
                <hr className='wkit-preset-line' />
                {('1' !== check_pro || sheCheck) &&
                    <>
                        {FreePro_filter()}
                        <hr className='wkit-preset-line' />
                    </>
                }
                {sheCheck ?
                    Sticky_header_filter()
                    :
                    Preset_tag_filter()
                }
            </div>
        )
    }

    const MobileMenu = () => {
        return (
            <>
                <div className='wkit-filter-fixed' onClick={() => { setMobileFilter(true) }}>
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.724998 7.9175L3.635 5L0.7175 2.0825C0.425 1.79 0.425 1.3175 0.7175 1.025C1.01 0.7325 1.4825 0.7325 1.775 1.025L5.2175 4.4675C5.51 4.76 5.51 5.2325 5.2175 5.525L1.775 8.9675C1.4825 9.26 1.01 9.26 0.7175 8.9675C0.4325 8.6825 0.432499 8.2025 0.724998 7.9175ZM8.75 0.5C8.3375 0.5 8 0.8375 8 1.25V8.75C8 9.1625 8.3375 9.5 8.75 9.5C9.1625 9.5 9.5 9.1625 9.5 8.75V1.25C9.5 0.8375 9.1625 0.5 8.75 0.5Z" fill="white" />
                    </svg>
                    {__('Filters', 'wdesignkit')}
                </div>
                {
                    MobileFilter &&
                    <div className='wkit-preset-mobile-filter'>
                        <span className='wkit-mobile-filter-close' onClick={() => { setMobileFilter(false) }}>
                            <svg width="13" height="13" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.40091 15.2558C1.66182 15.5169 2.01481 15.6637 2.38274 15.6637C2.75067 15.6637 3.10366 15.5169 3.36456 15.2558L8.29499 10.2193L13.2254 15.2558C13.5884 15.6217 14.118 15.7645 14.6141 15.6306C15.1103 15.4967 15.4981 15.1062 15.6309 14.6064C15.7639 14.1067 15.6221 13.5733 15.2588 13.2076L10.2587 8.24141L15.2588 3.27521C15.5659 2.91424 15.6703 2.42082 15.5365 1.96497C15.4027 1.50913 15.0485 1.15236 14.5959 1.01757C14.1431 0.882762 13.6535 0.987976 13.2949 1.29727L8.29499 6.26348L3.36455 1.29727C3.00619 0.987976 2.51632 0.882762 2.06375 1.01757C1.61119 1.15237 1.257 1.50911 1.12317 1.96497C0.989339 2.42082 1.0938 2.91424 1.40087 3.27521L6.3313 8.24141L1.40087 13.2076C1.11968 13.4728 0.959961 13.8436 0.959961 14.2316C0.959961 14.6198 1.11968 14.9904 1.40087 15.2557L1.40091 15.2558Z" fill="black"></path></svg>
                        </span>
                        {PresetFilterPanel()}
                    </div>
                }
            </>
        )
    }

    /** Checking for TPAE Plguin installation */
    const Install_Plugin = () => {
        setshowTpaePopup('loading');
        install_activate_plugin(tpae_plugin_detail).then(res => {
            if (res?.data?.success) {
                let index = she_plugins.current.findIndex((p_data) => p_data.p_id == '1005');
                if (index > -1) {
                    she_plugins.current.splice(index, 1);
                    let update_licence = Object.assign({}, manage_licence, { ['the-plus-addons-for-elementor-page-builder']: true })
                    setmanage_licence(update_licence);
                    check_tpae_plugin(currSheInfo.preset, currSheInfo.key)
                }

                SetShowInstallPopup(false);
                setshowTpaePopup(false);
                handlePresetDownload(currSheInfo?.preset, currSheInfo?.key);
                props.wdkit_set_toast([__('Installation Successful!', 'wdesignkit'), __('Plugin is installed', 'wdesignkit'), '', 'success']);

            } else {
                props.wdkit_set_toast([__('Installation Failed!', 'wdesignkit'), __('Plugin is not installed', 'wdesignkit'), '', 'danger']);
            }
        })
    }

    return (
        <div className={`wkit-preset-container ${loader ? 'wkit-skeleton' : ''} ${filterLoader ? 'wkit-filter-skeleton' : ''}`}>
            <div className='wkit-preset-filter-panel'>
                {PresetFilterPanel()}
            </div>
            {MobileMenu()}
            <div className='wkit-preset-main' style={{ display: MobileFilter ? 'none' : '' }}>
                <div className="wdkit-preset-inner-content">
                    {loader === false && presetData?.length <= 0 ?
                        <Wkit_availble_not />
                        :
                        <div className="wkit-preset-grid">
                            {loader === true ?
                                PresetSkeleton(presetField.perpage)
                                :
                                presetData?.map((data, index) => { return PresetCard(index, data) })
                            }
                        </div>
                    }
                </div>
                {Pagaination()}
            </div>
            {ShowInstallPopup &&
                <div className="wkit-overlay wkit-preset-popup" onClick={(e) => { Close_popup(e) }}>
                    {'elementor' === wdkitData?.use_editor && !showTpaePopup &&
                        <div className="tpae-nexter-bg">
                            <svg className="tpae-model-close" onClick={(e) => { Close_popup(e) }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="white" fillOpacity="0.8" /></svg>
                            <div className="tpae-nexter-content">
                                <div className="tpae-nexter-title">{__('Unlock all Premium Widget Designs with The Plus Addons for Elementor Pro', 'wdesignkit')}</div>
                                <ul className='wkit-tpae-ul-list'>
                                    <li>{CheckIcon}{__('120+ Elementor Widgets', 'wdesignkit')}</li>
                                    <li>{CheckIcon}{__('1000+ Elementor Templates', 'wdesignkit')}</li>
                                    <li>{CheckIcon}{__('Pre-Designed Widget Styled', 'wdesignkit')}</li>
                                    <li>{CheckIcon}{__('Trusted by 150K+ Users', 'wdesignkit')}</li>
                                </ul>
                                <div className="wkit-preset-popup-btns">
                                    <a className='tpae-nexter-btn' href='https://theplusaddons.com/pricing/?utm_source=wpbackend&utm_medium=dashboard&utm_campaign=plussettings' target="_blank" rel="noopener noreferrer">{__('Upgrade Pro', 'wdesignkit')}</a>
                                    <a className='tpae-nexter-btn wkit-activate-tpae ' href={getBaseUrl() + 'admin.php?page=theplus_welcome_page#/activate_pro'} target="_blank" rel="noopener noreferrer">{__('Already Pro? Activate Now', 'wdesignkit')}</a>
                                </div>

                                <div className="tpae-nexter-accordion">
                                    {elementor_poup_accordian?.map((item, index) => (
                                        <div key={index} className="nexter-accordion-item">
                                            <div className={`nexter-accordio-content ${activeIndex === index ? "tpae-content-opan" : ""}`} onClick={() => setActiveIndex(activeIndex === index ? null : index)}>
                                                <div className="tpae-accd-qui">{item.question}</div>
                                                <div className='tpae-pm-lable'>
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        {activeIndex !== index && (<path d="M10 4.16675V15.8334" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />)}
                                                        <path d="M4.16797 10H15.8346" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                            </div>
                                            <div className={`tpae-accordion-ans ${activeIndex === index ? "opan-accordion" : ""}`}>{item.answer}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    }
                    {'gutenberg' === wdkitData?.use_editor &&
                        <div className="tpae-nexter-bg wkit-nexter-bg">
                            <svg className="tpae-model-close" onClick={(e) => { Close_popup(e) }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="white" fillOpacity="0.8" /></svg>
                            <div className="tpae-nexter-content">
                                <div className="tpae-nexter-title">{__('Unlock all Premium Block Designs with Nexter Blocks Pro', 'wdesignkit')}</div>
                                <ul className='wkit-tpae-ul-list'>
                                    <li>{CheckIcon}{__('Performance Optimized', 'wdesignkit')}</li>
                                    <li>{CheckIcon}{__('90+ WordPress Blocks', 'wdesignkit')}</li>
                                    <li>{CheckIcon}{__('1000+ Pre-made Starter Templates', 'wdesignkit')}</li>
                                </ul>
                                <div className="wkit-preset-popup-btns">
                                    <a className='tpae-nexter-btn' href='https://nexterwp.com/pricing/' target="_blank" rel="noopener noreferrer">{__('Upgrade Pro', 'wdesignkit')}</a>
                                    <a className='tpae-nexter-btn wkit-activate-tpae ' href={getBaseUrl() + 'admin.php?page=nexter_welcome_page#/activate_PRO'} target="_blank" rel="noopener noreferrer">{__('Already Pro? Activate Now', 'wdesignkit')}</a>
                                </div>

                                <div className="tpae-nexter-accordion">
                                    {nexter_poup_accordian?.map((item, index) => (
                                        <div key={index} className="nexter-accordion-item">
                                            <div className={`nexter-accordio-content ${activeIndex === index ? "tpae-content-opan" : ""}`} onClick={() => setActiveIndex(activeIndex === index ? null : index)}>
                                                <div className="tpae-accd-qui">{item.question}</div>
                                                <div className='tpae-pm-lable'>
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        {activeIndex !== index && (<path d="M10 4.16675V15.8334" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />)}
                                                        <path d="M4.16797 10H15.8346" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                            </div>
                                            <div className={`tpae-accordion-ans ${activeIndex === index ? "opan-accordion" : ""}`}>{item.answer}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    }
                    {'elementor' === wdkitData?.use_editor && showTpaePopup && sheCheck && shePopuptype == 'the-plus-addons-for-elementor-page-builder' &&
                        <div className="tpae-nexter-bg">
                            <svg className="tpae-model-close" onClick={(e) => { Close_popup(e) }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="white" fillOpacity="0.8" /></svg>
                            <div className="tpae-nexter-content">
                                <div className="tpae-nexter-title tpae-nexter-popup-title">{__('Get a Free Elementor Navigation Menu Widget with The Plus Addons for Elementor', 'wdesignkit')}</div>
                                <div className="wkit-preset-popup-btns wkit-tpae-download-btn-container">
                                    {showTpaePopup == 'loading' ?
                                        <span className='wkit-tpae-download-btn'>
                                            <span className="wkit-loader"></span>
                                        </span>
                                        :
                                        <span className='wkit-tpae-download-btn' onClick={() => Install_Plugin()}>{__('Install Plus Addons for Elementor Plugin for Free Navigation Menu', 'wdesignkit')}</span>
                                    }

                                </div>
                                <div className="tpae-nexter-accordion tpae-nexter-popup-accord">
                                    {tpae_poup_accordian?.map((item, index) => (
                                        <div key={index} className="nexter-accordion-item">
                                            <div className={`nexter-accordio-content ${activeIndex === index ? "tpae-content-opan" : ""}`} onClick={() => setActiveIndex(activeIndex === index ? null : index)}>
                                                <div className="tpae-accd-qui">{item.question}</div>
                                                <div className='tpae-pm-lable'>
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        {activeIndex !== index && (<path d="M10 4.16675V15.8334" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />)}
                                                        <path d="M4.16797 10H15.8346" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                            </div>
                                            <div className={`tpae-accordion-ans ${activeIndex === index ? "opan-accordion" : ""}`}>{item.answer}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    }
                    {'elementor' === wdkitData?.use_editor && sheCheck && showTpaePopup && shePopuptype == 'elementor-pro' &&
                        <div className="tpae-nexter-bg wkit-bg-color">
                            <svg className="tpae-model-close" onClick={(e) => { Close_popup(e) }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="white" fillOpacity="0.8" /></svg>
                            <div className="tpae-nexter-content">
                                <div className="tpae-nexter-title">{__('Unlock This Sticky Header Template with Elementor Pro!', 'wdesignkit')}</div>
                                <div className='wkit-preset-subTitle'>{__('Access advanced design options like Sticky Headers, available only in Elementor Pro. Take your website\'s user experience to the next level!', 'wdesignkit')}</div>
                                <div className="wkit-preset-popup-btns">
                                    <a className='tpae-nexter-btn' href='https://elementor.com/pro/?utm_source=StickyHeaderElementor&utm_medium=ElementorProPro&utm_campaign=HeaderTemplates' target="_blank" rel="noopener noreferrer">{__('Get Elementor Pro', 'wdesignkit')}</a>
                                </div>
                                <div className="tpae-nexter-accordion">
                                    {elementor_pro_popup_accordian?.map((item, index) => (
                                        <div key={index} className="nexter-accordion-item">
                                            <div className={`nexter-accordio-content ${activeIndex === index ? "tpae-content-opan" : ""}`} onClick={() => setActiveIndex(activeIndex === index ? null : index)}>
                                                <div className="tpae-accd-qui">{item.question}</div>
                                                <div className='tpae-pm-lable'>
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        {activeIndex !== index && (<path d="M10 4.16675V15.8334" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />)}
                                                        <path d="M4.16797 10H15.8346" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                            </div>
                                            <div className={`tpae-accordion-ans ${activeIndex === index ? "opan-accordion" : ""}`}>{item.answer}</div>
                                        </div>
                                    ))}
                                </div>
                                <div className='wkit-elementor-notice'>
                                    <span>
                                        <svg width="30" height="30" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.37305 9.375C6.37305 9.1679 6.20515 9 5.99805 9C5.79095 9 5.62305 9.1679 5.62305 9.375V12.375C5.62305 12.5821 5.79095 12.75 5.99805 12.75C6.20515 12.75 6.37305 12.5821 6.37305 12.375V9.375Z" fill="white" fillOpacity="0.7" />
                                            <path fillRule="evenodd" clipRule="evenodd" d="M5.99805 4.5C3.02952 4.5 0.623047 6.90647 0.623047 9.875C0.623047 12.8435 3.02952 15.25 5.99805 15.25C8.9666 15.25 11.373 12.8435 11.373 9.875C11.373 6.90647 8.9666 4.5 5.99805 4.5ZM1.37305 9.875C1.37305 7.32068 3.44373 5.25 5.99805 5.25C8.55235 5.25 10.623 7.32068 10.623 9.875C10.623 12.4293 8.55235 14.5 5.99805 14.5C3.44373 14.5 1.37305 12.4293 1.37305 9.875Z" fill="white" fillOpacity="0.7" />
                                            <path d="M6.49805 7.875C6.49805 8.15114 6.2742 8.375 5.99805 8.375C5.7219 8.375 5.49805 8.15114 5.49805 7.875C5.49805 7.59886 5.7219 7.375 5.99805 7.375C6.2742 7.375 6.49805 7.59886 6.49805 7.875Z" fill="white" fillOpacity="0.7" />
                                        </svg>
                                    </span>
                                    <span className='wkit-preset-notice-text'>
                                        {__('Note :- If you\'re looking for a Free option, simply select the Filter Free option in Template. You can still import templates made using the Free Navigation Menu Widget from The Plus Addons for Elementor.', 'wdesignkit')}
                                    </span>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        </div >
    )
}

const activae_page = state => ({
    wdkit_meta: state.wdkit_meta_data.wdkitmeta,
})

const mapDispatchToProps = dispatch => ({
    wdkit_set_toast: data => dispatch(ShowToast(data)),
});

export default connect(activae_page, mapDispatchToProps)(Preset);